import { Link, createSearchParams, URLSearchParamsInit, useNavigate } from 'react-router-dom';
import { ReactComponent as ArrowLongLeft } from 'src/assets/arrow-long-left.svg';
import css from './breadcrumbs.module.scss';

interface BreadcrumbsProps {
  title: string;
  pages?: {
    path: string;
    title: string;
  }[];
  searchParams?: URLSearchParamsInit;
}

export default function Breadcrumbs({ pages, title, searchParams }: Readonly<BreadcrumbsProps>) {
  const navigate = useNavigate();

  const modifyTitle = (toEdit: string) => (toEdit?.length >= 32 ? `${toEdit?.substring(0, 32)}...` : toEdit);

  return (
    <div className={css.breadcrumbsWrapper}>
      <button
        className={css.backButton}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          navigate(-1);
        }}>
        <ArrowLongLeft />
        <p>назад</p>
      </button>
      <div className={css.breadcrumbs}>
        <Link to='/' title='Головна'>
          Головна{' '}
        </Link>
        {pages?.map((p, i) => {
          return (
            p && (
              <Link
                key={`${p.title}_${i}`} /* NOSONAR */
                title={p.title}
                to={{
                  pathname: p.path,
                  search: createSearchParams(searchParams).toString()
                }}>
                {modifyTitle(p.title)}
              </Link>
            )
          );
        })}
        <p title={title}>{modifyTitle(title)}</p>
      </div>
    </div>
  );
}
